export const ESTABLISHMENT_PAYMENT_BLOCKED_CODE = "ESTABLISHMENT_PAYMENT_BLOCKED";

/**
 * Detecta o 403 disparado pelo server-meulance quando o Establishment está
 * bloqueado por atraso na assinatura recorrente do clube (módulo separado
 * — login e navegação geral do app nunca são afetados, só as rotas desse
 * estabelecimento específico).
 */
export function isEstablishmentBlockedError(error: unknown): boolean {
  const code = (error as { response?: { data?: { code?: string } } })?.response?.data?.code;
  return code === ESTABLISHMENT_PAYMENT_BLOCKED_CODE;
}

/**
 * Rotas cobertas pelo bloqueio de painel no server-meulance (ver
 * `requireOwnerPanelNotBlocked` lá) — usado aqui só pra decidir quando uma
 * resposta 200 nessas mesmas rotas pode limpar o aviso (assinatura reativada).
 */
const GATED_PATH_PREFIX = /^\/app\/(establishments|lives|media|analytics)(\/|$)/;

export function isGatedPanelPath(url?: string): boolean {
  return !!url && GATED_PATH_PREFIX.test(url);
}

export type EstablishmentBlockedState = {
  blocked: boolean;
};

let state: EstablishmentBlockedState = { blocked: false };
let listeners: Array<() => void> = [];

function emit() {
  listeners.forEach((listener) => listener());
}

export function getEstablishmentBlockedState(): EstablishmentBlockedState {
  return state;
}

export function subscribeEstablishmentBlocked(listener: () => void): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

export function setEstablishmentBlocked(): void {
  if (state.blocked) return;
  state = { blocked: true };
  emit();
}

export function clearEstablishmentBlocked(): void {
  if (!state.blocked) return;
  state = { blocked: false };
  emit();
}
